module.exports = __webpack_public_path__ + "img/help2.c2f38b51.png";